import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from "@nuxtjs/composition-api";

import { useTranslate } from "@/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'CartsDrawerHeader',
  props: {
  title: {
    type: String,
    default: "",
  },
  showBack: {
    type: Boolean,
    default: false,
  },
},
  emits: ["back", "close"],
  setup(__props, { emit }: { emit: ({
  (e: "back"): void;
  (e: "close"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const { t } = useTranslate();

const { title, showBack } = toRefs(props);

const titleText = computed(() => {
  if (title.value) {
    return title.value;
  }
  return t("My Carts").value;
});

const onBack = () => {
  emit("back");
};

const onCloseDrawer = () => {
  emit("close");
};

return { __sfc: true,props, emit, t, title, showBack, titleText, onBack, onCloseDrawer }
}

})